module.exports = __webpack_public_path__ + "static/media/blocked-page-image.5161cbdc.svg";